import {
  camelCaseKeysDeep,
} from 'utils/dataUtils';

import authenticatedRequest from './authenticatedRequest';

const fetchCurrentUser = ({ locale }) => authenticatedRequest({
  verb: 'GET',
  path: `v1.2.0/${locale}/users/me`,
}).then((response) => camelCaseKeysDeep(response.data.user));

export default fetchCurrentUser;
